import React from 'react';

import styles from "../../../styles/athlete-widget.placeholder.module.scss"
import classNames from "classnames";


export const AthleteWidgetSubDetailsPlaceholder = ({device}) => {
  return (
    <div className={classNames(styles.sub_details_container)}>
      <div className={classNames(styles.rect)}/>
      <div className={classNames(styles.rect)}/>
      <div className={classNames(styles.rect)}/>
    </div>
  )
}
